"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScrollLock = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = require("@emotion/react");
var React = __importStar(require("react"));
require("./scrollLock.css");
var ScrollLock = /** @class */ (function (_super) {
    __extends(ScrollLock, _super);
    function ScrollLock(props) {
        var _this = _super.call(this, props) || this;
        _this.getChildRects = function () { var _a; return (_a = _this.childElementRef.current) === null || _a === void 0 ? void 0 : _a.getClientRects()[0]; };
        _this.getParentRects = function () { var _a; return (_a = _this.parentElementRef.current) === null || _a === void 0 ? void 0 : _a.getClientRects()[0]; };
        _this.handlResize = function () {
            var _a;
            return _this.setState({
                childWidth: _this.state.lock !== 'original-position' ? (_a = _this.getParentRects()) === null || _a === void 0 ? void 0 : _a.width : undefined,
            });
        };
        _this.getMeasures = function () {
            var childRects = _this.getChildRects();
            var parentRects = _this.getParentRects();
            if (!childRects ||
                !parentRects ||
                document.body.scrollHeight - document.documentElement.clientHeight <=
                    ScrollLock.MIN_DOCUMENT_HEIGTH_THRESHOLD) {
                return undefined;
            }
            var measures = {
                childTopPosition: childRects.y,
                parentTopPosition: parentRects.y,
                clientHeight: document.documentElement.clientHeight,
                childHeight: childRects.height,
                parentHeight: parentRects.height,
                parentWidth: parentRects.width,
                parentChildTopPositionDifference: parentRects.y - childRects.y,
            };
            return _this.props.type === 'float'
                ? _this.positionSetterForFloat(measures)
                : _this.positionSetterForFixed(measures);
        };
        _this.positionSetterForFloat = function (measures) {
            return window.requestAnimationFrame(function () {
                var childHeight = measures.childHeight, childTopPosition = measures.childTopPosition, parentHeight = measures.parentHeight, parentWidth = measures.parentWidth, parentTopPosition = measures.parentTopPosition, clientHeight = measures.clientHeight, parentChildTopPositionDifference = measures.parentChildTopPositionDifference;
                var parentBottomPosition = parentTopPosition + parentHeight;
                var childBottomPosition = childTopPosition + childHeight;
                var bottom = clientHeight - childBottomPosition;
                if (parentChildTopPositionDifference > _this.props.offset) {
                    return _this.setState({
                        lock: 'original-position',
                        childWidth: parentWidth,
                    });
                }
                if ((_this.state.lock === 'original-position' && bottom >= _this.props.offset) ||
                    (_this.state.lock === 'lock-absolute' && bottom <= _this.props.offset)) {
                    return _this.setState({
                        lock: 'lock-fixed',
                        childWidth: parentWidth,
                    });
                }
                if (_this.state.lock !== 'original-position' &&
                    parentBottomPosition - childBottomPosition <= _this.props.offset) {
                    return _this.setState({
                        lock: 'lock-absolute',
                        childWidth: parentWidth,
                    });
                }
            });
        };
        _this.positionSetterForFixed = function (measures) {
            return window.requestAnimationFrame(function () {
                var childTopPosition = measures.childTopPosition, parentWidth = measures.parentWidth, parentChildTopPositionDifference = measures.parentChildTopPositionDifference;
                if (_this.state.lock === 'original-position' &&
                    childTopPosition <= _this.props.offset + ScrollLock.FIXED_TO_ORIGINAL_THRESHOLD) {
                    return _this.setState({
                        lock: 'lock-fixed',
                        childWidth: parentWidth + ScrollLock.WIDTH_MARGIN_FOR_FIXED_ELEMENTS,
                    });
                }
                if (_this.state.lock === 'lock-fixed' &&
                    parentChildTopPositionDifference > ScrollLock.FIXED_TO_ORIGINAL_THRESHOLD) {
                    return _this.setState({
                        lock: 'original-position',
                        childWidth: parentWidth,
                    });
                }
            });
        };
        _this.mapStateToCustomStyle = function (lock) {
            var _a;
            switch (lock) {
                case 'lock-fixed':
                    return __assign((_a = { position: 'fixed' }, _a[_this.props.onScrollLockPosition] = _this.props.offset, _a), _this.props.childElementOverrideStyle);
                case 'lock-absolute':
                    return __assign({ position: 'absolute', bottom: _this.props.offset }, _this.props.childElementOverrideStyle);
                case 'original-position':
                    return { width: _this.state.childWidth };
            }
        };
        _this.mapCssToParentElement = function () {
            var _a;
            return ({
                height: _this.props.type === 'fixed' ? (_a = _this.getChildRects()) === null || _a === void 0 ? void 0 : _a.height : '100%',
            });
        };
        _this.renderLock = function () {
            return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "scroll-lock parent", css: (0, react_1.css)(__assign(__assign({}, _this.mapCssToParentElement()), _this.props.parentElementOverrideStyle)), ref: _this.parentElementRef }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: "scroll-lock-children", css: (0, react_1.css)(__assign(__assign({}, _this.mapStateToCustomStyle(_this.state.lock)), { width: _this.state.childWidth })), ref: _this.childElementRef }, { children: _this.props.children })) })));
        };
        _this.childElementRef = React.createRef();
        _this.parentElementRef = React.createRef();
        _this.state = {
            lock: 'original-position',
            childWidth: undefined,
            clientHeight: document.documentElement.clientHeight,
        };
        return _this;
    }
    ScrollLock.prototype.componentDidMount = function () {
        if (!this.props.doNotLockWhen) {
            window.addEventListener('scroll', this.getMeasures);
            window.addEventListener('resize', this.handlResize);
        }
    };
    ScrollLock.prototype.componentDidUpdate = function () {
        var _a;
        if ((this.props.forceReflow || this.props.doNotLockWhen) && this.state.lock !== 'original-position') {
            this.setState({
                lock: 'original-position',
                childWidth: (_a = this.getParentRects()) === null || _a === void 0 ? void 0 : _a.width,
            });
        }
    };
    ScrollLock.prototype.componentWillUnmount = function () {
        window.removeEventListener('scroll', this.getMeasures);
        window.removeEventListener('resize', this.handlResize);
    };
    ScrollLock.prototype.render = function () {
        return this.props.doNotLockWhen ? this.props.children : this.renderLock();
    };
    // General css useful for fixed compenents to completely cover underlying scrolling elements
    ScrollLock.overrideCss = {
        backgroundColor: '#ffffff',
        zIndex: 1005,
    };
    // Miniminum document height to trigger scroll lock
    ScrollLock.MIN_DOCUMENT_HEIGTH_THRESHOLD = 500;
    ScrollLock.FIXED_TO_ORIGINAL_THRESHOLD = 10;
    ScrollLock.WIDTH_MARGIN_FOR_FIXED_ELEMENTS = 20;
    return ScrollLock;
}(React.PureComponent));
exports.ScrollLock = ScrollLock;
ScrollLock.defaultProps = {
    forceReflow: false,
    onScrollLockPosition: 'top',
    offset: 0,
    preventLock: false,
};
//# sourceMappingURL=ScrollLock.js.map